import React from "react";

interface ProgressBarProps {
  progress: number; // 0-100
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <div
      className="relative h-[14px] w-full overflow-hidden rounded-full border border-gray bg-white/60"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.floor(progress)}
      aria-valuetext={`${Math.floor(progress)} percent`}>
      <div className="h-full bg-lac-leman transition-all duration-300" style={{ width: `${progress}%` }} />
    </div>
  );
};

export default ProgressBar;
